<template>
    <v-container fluid class="pb-0">
        <div>
            <template>
                <v-row class="h-100">
                    
                    <v-col cols="12" class="pt-1 pb-0">
                        <SearchPatient></SearchPatient>
                    </v-col>

                </v-row>
            </template>
        </div>
    
    </v-container>
</template>

<script>

import {mapState, mapActions} from 'vuex';
import SearchPatient from '../../../components/process/SearchPatient'

export default {
    name: 'Process',
    components: {
        SearchPatient
    },
    data() {
        return {
            
        }
    },
    computed: {

    },
    methods: {
        
        
        
    },

}
</script>

<style scoped>

</style>